var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-vertical-container"},[(_vm.description)?_c('h5',[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e(),_c('iframe',{staticClass:"resp-iframe",attrs:{"src":_vm.src,"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }